<template>
  <AppLayout>
    <template #subheader>
      <div class="d-flex align-items-center justify-content-between w-100 flex-wrap gap-3">

        <div class="d-flex align-items-center me-2">
          <Link
              v-if="isAdmin()"
              class="btn btn-sm btn-outline-primary"
              :href="route('articleWarehouses.index')"
          >
            Magazyny
          </Link>
        </div>

      </div>
    </template>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading d-block">
          <ul style="list-style-type: none; padding: 0" v-for="error in $page.props.flash.errors">
            <li class="alert alert-danger">{{ error }}</li>
          </ul>
        </div>

        <div class="widget-content">
          <div>
            <ejs-grid ref="warehouseStockLevelsGrid" id="warehouseGrStockLevelsidId" height="58vh"
                      :dataSource="warehouseDataManager"
                      :allowTextWrap='false'
                      :allowExcelExport='true'
                      :allowPaging="true"
                      :allowSorting='true'
                      :allowFiltering='true'
                      :allowReordering='true'
                      :allowResizing='true'
                      :showColumnChooser='true'
                      :allowSelection='true'
                      :enablePersistence='true'
                      :pageSettings="pageSettings"
                      :editSettings="editSettings"
                      :filterSettings="filterOptions"
                      :selectionSettings="selectionOptions"
                      :toolbar="toolbar"
                      :contextMenuItems="contextMenuItems"
                      @contextMenuOpen="onContextMenuOpen"
					  :rowSelecting="rowSelecting"
					  :rowSelected="onRowSelected"
					  :rowDeselected="onRowDeselected"
                      @queryCellInfo="queryCellInfo"
                      :toolbarClick="clickToolbarHandler"
                      :contextMenuClick="clickContextMenuHandler"
                      :actionBegin="actionBegin"
                      :actionComplete="actionComplete"
                      :keyPressed="onKeyDown">
              <e-columns>
                <e-column type="checkbox" width="100" :allowSorting="false"/>
                <e-column field="id" headerText="ID" width="100" :isPrimaryKey="true" :visible="false"
                          :allowSorting="false" :allowEditing="false"/>
                <e-column field="article_warehouse.short_name" headerText="Magazyn" type="string"
                          :filter="filterWarehouses"></e-column>						  
                <e-column field="article_id" headerText="ID artykułu" :visible="false"></e-column>
                <e-column field="article.catalog_number" headerText="Nr artykułu" type="string"
                          :filter="filterDefault"></e-column>
                <e-column field="article.model" headerText="Model artykułu" type="string"
                          :filter="filterDefault"></e-column>
                <e-column field="article.description" headerText="Nazwa/Opis" :defaultValue="null" width="200"
                          type="string" :filter="filterDefault"></e-column>
                <e-column field="article.article_unit.id" headerText="J.m." width="150" editType="dropdownedit"
                          :dataSource="units" foreignKeyValue='name' foreignKeyField='id' type="string"
                          :filter='filterUnits'></e-column>
                <e-column field="quantity" headerText="Ilość" format="N2" type="number" :allowEditing="false"></e-column>
                <e-column field="article.location" headerText="Lokalizacja" :defaultValue="null" width="200"
                          type="string" :filter="filterDefault"></e-column>
                <template v-if="hasPermission('canViewArticlesPricesAndHistory')">
                  <e-column field="article.price_netto_zl" headerText="Cena Netto zł" width="150" format="N2"
                            type="number" :filter="filterDefault"></e-column>
                </template>						  
				<e-column field="producer_name" headerText="Producent" width="150"type="string" :allowSorting="false" :allowFiltering="false"></e-column>
                <e-column field="article.details" headerText="Sczegóły" type="string" :defaultValue="null" width="200"
                          :filter="filterDefault"></e-column>
                <e-column field="article.link" headerText="Link" :defaultValue="null" :filter="filterDefault"
                          type="string"
                          :template="'linkTemplate'"></e-column>
                <e-column field="article.photos" headerText="Zdjęcie" width="200" :template="'imageTemplate'"
                          :allowFiltering="false" :allowSorting="false"></e-column>
                <e-column field="created_at" headerText="Utworzono" width="150" type="date"
                          format="dd.MM.yyyy HH:mm:ss"></e-column>
                <e-column field="article.created_by.id" headerText="Utworzył" width="150" type="string"
                          :dataSource="users" foreignKeyValue='name' foreignKeyField='id'
                          :defaultValue="$page.props.user.id" :filter="filterCreatedBy"></e-column>
                <e-column field="article.customer_category.id" headerText="Kategoria" width="250"
                          :dataSource="categories" foreignKeyValue='name' foreignKeyField='id' type="string"
                          :filter='filterCategories'></e-column>
                <template v-if="hasPermission('canViewArticlesPricesAndHistory')">
                  <e-column field="article.price_brutto_zl" headerText="Cena brutto zł" width="150" format="N2"
                            type="number" :filter="filterDefault"></e-column>
                  <e-column field="article.vat" headerText="vat" type="number" editType="numericedit"
                            :filter="filterDefault"></e-column>
                  <e-column field="article.price_netto_zl" headerText="Wartość Netto Zł" type="number"
                            :allowEditing="false"
                            :allowSorting="false"
                            :allowFiltering="false" :template="'valueTemplate'"></e-column>
                </template>
                <e-column field="suppliers_short_names" headerText="Dostawca" width="150" editType="string" :allowSorting="false" :allowFiltering="false"></e-column>
                <e-column field="updated_at" headerText="Ostatnia aktualizacja"
                          format="dd.MM.yyyy"
                          :filter="filterDefault"></e-column>
              </e-columns>

              <template v-slot:valueTemplate="{data}">
                {{ ((data.article.price_netto_zl ?? 0) * (data.quantity ?? 1)).toFixed(2).replace('.', ',') }}
              </template>

              <template v-slot:linkTemplate="{data}">
                <a class="link link-primary" target="_blank" rel="noopener noreferrer" :href=data.article.link>{{
                    data.article.link
                  }}</a>
              </template>

              <template v-slot:imageTemplate="{data}">
                <img v-if="data.article.photos && data.article.photos.length > 0"
                     :src="`/${data.article.photos[0].photo_path}`" alt="Zdjęcie" style="max-height: 100px;"/>
              </template>

            </ejs-grid>
          </div>

          <div class="mt-2" v-if="selectedArticle">
            <button @click="selectDetailsBtn('columns')" class="btn btn-outline-secondary me-2"
                    :class="{'active':selectedDetailWindow==='columns'}">Kolumny
            </button>
            <button @click="selectDetailsBtn('details')" class="btn btn-outline-secondary me-2"
                    :class="{'active':selectedDetailWindow==='details'}">Szczegóły artykułu
            </button>
            <button @click="selectDetailsBtn('history')" class="btn btn-outline-secondary"
                    :class="{'active':selectedDetailWindow==='history'}">Historia magazynowa
            </button>

            <div class="mt-2">
              <ViewArticleWarehouseMovementDetails v-if="selectedDetailWindow === 'history'"
                                                   :selectedArticle="selectedArticle"/>
              <ViewArticleWarehouseDetails v-if="selectedDetailWindow === 'details'"
                                           :selectedArticle="selectedArticle"/>
              <ViewArticleWarehouseVerticalColumns v-if="selectedDetailWindow === 'columns'"
                                                   :selectedRecord="selectedArticle"/>
            </div>
          </div>

          <MoveItemToWarehouseModal v-if="showMoveItemToWarehouseModal" ref="moveItemToWarehouseModal"
                                    :selectedItems="selectedArticle"
									:customers="customers"
                                    @update-grid="updateGrid()"
                                    @added-success="successMsg" @added-error="errorMsg"
                                    @data-changed="updateGrid()"/>

          <AddStockWarehouseModal v-if="showAddStockWarehouseModal" ref="addStockWarehouseModalRef" :warehouses="warehouses" @added-success="successMsg" @added-error="errorMsg"
                                  @added-movement="updateGrid()"   @data-saved="updateGrid()"/>
								  
         <AddDocumentModal v-if="showAddDocumentModal" ref="addDocumentModalRef" @added-success="successMsg" @added-error="errorMsg"
		 :customers="customers" :warehouses="warehouses" @added-movement="updateGrid()"   @data-saved="updateGrid()"/>
								  
								  

        </div>
      </div>
    </div>


  </AppLayout>
</template>

<script>
import AppLayout from "../../Layouts/App.vue";
import {usePage} from "@inertiajs/vue3";
import {MultiSelect} from '@syncfusion/ej2-vue-dropdowns';
import {
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  Edit,
  ExcelExport,
  Filter,
  ForeignKey,
  GridComponent,
  Page,
  Reorder,
  Resize,
  Sort,
  Toolbar,
  Group,
} from '@syncfusion/ej2-vue-grids';
import {createElement} from "@syncfusion/ej2-base";
import {DataManager, Predicate, Query, WebMethodAdaptor} from '@syncfusion/ej2-data';
import {ComboBox, DropDownList} from "@syncfusion/ej2-dropdowns";
import moment from "moment";
import {ref} from "vue";

import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import ViewArticleWarehouseMovementDetails from "./Articles/ViewArticleWarehouseMovementDetails.vue";
import ViewArticleWarehouseVerticalColumns from "./ViewArticleWarehouseVerticalColumns.vue";
import ViewArticleWarehouseDetails from "./ViewArticleWarehouseDetails.vue";
import MoveItemToWarehouseModal from "../OrderLists/MoveItemToWarehouseModal.vue";
import AddStockWarehouseModal from "./AddStockWarehouseModal.vue";
import AddDocumentModal from "./AddDocumentModal.vue";

const {hasRole, hasPermission} = usePermission();


let ddElem, multiSelectObj, dropInstanceFilterUnits, statusElem, statusObj;
export default {

  components: {
    AddStockWarehouseModal,
	AddDocumentModal,
    MoveItemToWarehouseModal,
    hasPermission,
    ViewArticleWarehouseVerticalColumns,
    ViewArticleWarehouseMovementDetails,
    ViewArticleWarehouseDetails,
    AppLayout,
    MultiSelect,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective
  },

  provide: {
    grid: [Page, Edit, Toolbar, ContextMenu, Sort, Filter, Reorder, Resize, ColumnChooser, ExcelExport, ForeignKey, Group]
  },

  props: {
    projects: Object,
    order_list_statuses: Object,
    units: Object,
    categories: Object,
    users: Object,
    producers: Object,
    suppliers: Object,
    warehouses: Object,
		customers: {
      type: Array,
      default: () => []
    },
	table_settings: {
        type: Object,
        default: null
   },
	now_restore_table: {
		type: Number,
		default: 1
	}
  },

  beforeMount() {
    this.getWarehousesItemsForProject();
	
  },

  mounted() {
	this.restoreTableIfNeeded();
    this.$nextTick(() => {
      const gridEl = document.getElementById('warehouseGrStockLevelsidId');
      if (!gridEl) return;

      gridEl.addEventListener('mousedown', (e) => {
        if (e.which === 3) { // PPM
          this.preventRightClickSelection = true;
        }
      });
	  this.applyTableSettings();
    });
  },

  data() {

    const createSuppliersFn = () => {
      ddElem = document.createElement('input');
      return ddElem;
    };

    const readSuppliersFn = () => {
      return multiSelectObj.value.join(","); // Zwróć wartości jako string
    };

    const destroySuppliersFn = () => {
      multiSelectObj.destroy(); // Usunięcie instancji MultiSelect
    };

    const writeSuppliersFn = (args) => {
      const selectedValues = args.rowData.article.suppliers_short_names ? args.rowData.article.suppliers_short_names.split(",") : [];

      // Inicjalizacja MultiSelect
      multiSelectObj = new MultiSelect({
        value: selectedValues,
        dataSource: this.suppliers,
        fields: {text: "short_name", value: "short_name"},
        placeholder: 'Wybierz dostawców',
        mode: 'Box',
        allowFiltering: true,
        popupHeight: '200px',
        closePopupOnSelect: false,
      });

      multiSelectObj.appendTo(ddElem);
    };

    return {
	            tableSettingsApplied: false,
            hasTableSettings: false,
	  showAddStockWarehouseModal: false,
	  showAddDocumentModal: false,
	  showMoveItemToWarehouseModal: false,
      hasPermission,
      preventRightClickSelection: false,
      teams: [],
      initialGrouping: true,
      warehouseDataManager: [],
      fetchedOrders: [],
      selectedProjectId: 0,
      selectedTeamName: null,
      addRequiredProjectItemsModalRef: ref(null),
      editArticleModalRef: ref(null),
      showEditArticleModal: false,
      selectedArticle: null,
      selectedDetailWindow: 'columns',
      selectedRecordsToSendOrder: null,
      pageSettings: {pageSize: 30, pageCount: 5, pageSizes: [10, 20, 30, 50, 100]},
      filterOptions: {
        type: "Menu",
        operator: 'contains',
        columns: [{
          field: 'article_warehouse.short_name',
          matchCase: false,
          predicate: 'and',
          operator: 'startswith',
          value: 'Główny'
        }]
      },
      selectionOptions: {
  checkboxOnly: true,
  persistSelection: true,
  type: 'Multiple'
},
      filterDefault: {operator: 'contains', params: {minLength: 2}},
      isRestoring: false,
      toolbar: this.getToolbar(),
      editSettings: this.getEditSettings(),
      contextMenuItems: this.getContextMenu(),
      suppliersParams: {
        create: createSuppliersFn,
        destroy: destroySuppliersFn,
        read: readSuppliersFn,
        write: writeSuppliersFn
      },

      currenciesParams: {
        create: () => {
          return document.createElement('input');
        },
        read: () => {
          return this.comboBoxObj.value;
        },
        destroy: () => {
          this.comboBoxObj.destroy();
        },
        write: (args) => {
          this.comboBoxObj = new ComboBox({
            dataSource: [
              {text: 'ZŁ', value: 'ZŁ'},
              {text: 'EUR', value: 'EUR'},
              {text: 'USD', value: 'USD'},
            ],
            fields: {text: "text", value: "value"},
          });
          this.comboBoxObj.appendTo(args.element);
        }
      },

      filterUnits: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.units,
              fields: {text: 'name', value: 'id'},
              placeholder: 'Szukaj jednostki',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterCategories: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.categories,
              fields: {text: 'name', value: 'id'},
              placeholder: 'Szukaj kategorii',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterWarehouses: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.warehouses,
              fields: {text: 'short_name', value: 'id'},
              placeholder: 'Szukaj magazynu',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterCreatedBy: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.users,
              fields: {text: 'name', value: 'id'},
              placeholder: 'Szukaj kto stworzył',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      orderItemStatusesParams: {
        create: () => {
          statusElem = document.createElement('input');
          return statusElem;
        },
        read: () => {
          return statusObj.text;
        },
        destroy: () => {
          statusObj.destroy();
        },
        write: () => {
          statusObj = new DropDownList({
            dataSource: this.order_list_statuses,
            fields: {value: 'id', text: 'name'},
            enabled: true,
            placeholder: 'Wybierz status',
            floatLabelType: 'Never',
          });
          statusObj.appendTo(statusElem);
        }
      },

      orderItemWarehousesParams: {
        create: () => {
          statusElem = document.createElement('input');
          return statusElem;
        },
        read: () => {
          return statusObj.text;
        },
        destroy: () => {
          statusObj.destroy();
        },
        write: () => {
          statusObj = new DropDownList({
            dataSource: this.warehouses,
            fields: {value: 'id', text: 'short_name'},
            enabled: true,
            placeholder: 'Wybierz magazyn',
            floatLabelType: 'Never',
            change: async (event) => {
              statusObj.value = await this.onChangeWarehouse(event)
            }
          });
          statusObj.appendTo(statusElem);
        }
      },

      inventoryStatusesParams: {
        create: () => {
          statusElem = document.createElement('input');
          return statusElem;
        },
        read: () => {
          return statusObj.text;
        },
        destroy: () => {
          statusObj.destroy();
        },
        write: () => {
          statusObj = new DropDownList({
            dataSource: this.inventory_statuses,
            fields: {value: 'name', text: 'name'},
            enabled: true,
            placeholder: 'Wybierz status',
            floatLabelType: 'Never'
          });
          statusObj.appendTo(statusElem);
        }
      },
    }
  },
    watch: {
        table_settings: {
            immediate: true,
            deep: true,
            handler(value) {
                this.hasTableSettings = !!(value?.settings);

                this.$nextTick(() => {
                    const grid = this.$refs.warehouseStockLevelsGrid?.ej2Instances;

                    if (grid) {
                        grid.toolbar = this.getToolbar();
                    }
                });
            }
        }
    },
  methods: {
	  restoreTableIfNeeded() {
		if (this.now_restore_table !== 0) {
		  return;
		}

		let grid = this.$refs.warehouseStockLevelsGrid;

		if (!grid || !grid.$el || !grid.ej2Instances) {
		  return;
		}

		let gridName = 'grid' + grid.$el.id;

		grid.ej2Instances.enablePersistence = false;

		window.localStorage.setItem(gridName, "");

		grid.ej2Instances.destroy();

		(function stripIdsFromUrl() {
		  try {
			const url = new URL(window.location.href);

			url.searchParams.delete('ids');
			url.searchParams.delete('ids[]');

			history.replaceState(
			  history.state,
			  '',
			  url.toString()
			);
		  } catch (e) {
			const href = window.location.href;

			const cleaned = href
			  .replace(/([?&])ids(\[\])?=[^&#]*&?/g, '$1')
			  .replace(/[?&]$/, '');

			history.replaceState(
			  history.state,
			  '',
			  cleaned
			);
		  }
		})();
		this.applyTableSettings();
		location.reload();
	  },  
          applyTableSettings() {
            const grid = this.$refs.warehouseStockLevelsGrid?.ej2Instances;
            if (!grid || !this.table_settings?.settings) {return;}
            let settings;
            try {
                settings = JSON.parse(this.table_settings.settings);
            } catch (error) {
                console.error('Błąd odczytu ustawień tabeli:', error);
                return;
            }
            if (!Array.isArray(settings)) {
                return;
            }

            settings.forEach(setting => {
                if (!setting.field) {return;}
                const column = grid.columns.find(
                    col => col.field === setting.field
                );
                if (!column) {return;}
                if (setting.width !== undefined) {
                    column.width = setting.width;
                }
                column.visible = setting.visible !== false;
            });

            grid.refreshColumns();

            const savedFields = settings
                .filter(setting => setting.field)
                .sort((a, b) => a.index - b.index)
                .map(setting => setting.field);
            const currentFields = grid.columns
                .filter(column => column.field)
                .map(column => column.field);
            savedFields.forEach((field, targetIndex) => {
                const currentIndex = currentFields.indexOf(field);
                if (currentIndex === -1 || currentIndex === targetIndex) {
                    return;
                }
                const targetField = currentFields[targetIndex];
                if (!targetField) {return;}
                grid.reorderColumns(
                    field,
                    targetField
                );
                currentFields.splice(currentIndex, 1);
                currentFields.splice(targetIndex, 0, field);
            });

            grid.refreshColumns();
        },
  onRowDeselected() {
    const selected = this.$refs.warehouseStockLevelsGrid.ej2Instances.getSelectedRecords()
    if (selected.length === 0) {
      this.selectedArticle = null // brak zaznaczeń → schowaj sekcję
    } else {
      this.selectedArticle = selected[0] // pierwszy pozostający zaznaczony
    }
  },

    getEditSettings() {
      return {
        allowEditing: false,
        allowAdding: hasPermission('canWarehouseDispositions'),
        allowDeleting: false,
        showConfirmDialog: false,
        showDeleteConfirmDialog: false,
        mode: 'Batch',
        newRowPosition: 'Top',
      };
    },

        getToolbar() {
            const tools = [];
			if(hasPermission('canWarehouseDispositions')){ tools.push(
        {text: "Dodaj PW", prefixIcon: 'e-add', id: 'add_btn'},
        {text: "Ruch magazynowy", prefixIcon: 'e-add', id: 'add_btn2'});
       }
		tools.push(
		{text: "Resetuj filtry", prefixIcon: 'e-reset', id: 'reset_filters'},
 		{text: "Pokaż stany niezerowe", prefixIcon: 'e-filter', id: 'show_non_zero'},
        {text: "Search", prefixIcon: 'e-search', id: "search", align: 'center'},
                { text: "Zapisz ustawienia", prefixIcon: 'e-save', id: "save", align: 'right' });
			if (this.hasTableSettings) {
                tools.push({ text: "Usuń ustawienia", prefixIcon: 'e-delete', id: "delete-set", align: 'right' });
            }
            tools.push({text: "Przywróć domyślny", prefixIcon: 'e-undo', id: "restore", align: 'right'},
        {text: "Export do Excela", prefixIcon: 'e-excelexport', id: "excelexport", align: 'right'},
        "ColumnChooser");
			return tools;
    },

    queryCellInfo(args) {
      // Sprawdź, czy artykuł został usunięty
      if (args.column.field === "article.catalog_number" || args.column.field === "article.model") {
        if (args.data.article && args.data.article.deleted_at) {
          args.cell.setAttribute('title', 'Ten artykuł został usunięty!');
          args.cell.classList.add("deleted-article");
        }
      }
    },

    clickToolbarHandler: async function (args) {
      /**
       * Akcja przy kliknięciu dodawania stanu
       */
      if (args.item.id === 'add_btn') {
	  this.showAddStockWarehouseModal = true;
	  this.$nextTick(() => {
        this.$refs.addStockWarehouseModalRef.show();
		});
      }
      if (args.item.id === 'add_btn2') {
	    this.showAddDocumentModal = true;
		this.$nextTick(() => {
        this.$refs.addDocumentModalRef.show();
		});
      }
      /**
       * Akcja przy kliknięciu resetowania filtrów
       */
      if (args.item.id === 'reset_filters') {
        this.$refs.warehouseStockLevelsGrid.clearFiltering();
      }

      if (args.item.id === 'show_non_zero') {
        this.$refs.warehouseStockLevelsGrid.clearFiltering();
        this.$refs.warehouseStockLevelsGrid.filterByColumn('quantity', 'greaterthan', [0]);
      }
            if (args.item.id === 'save') {
                const grid = this.$refs.warehouseStockLevelsGrid?.ej2Instances;

                if (!grid) {
                    console.warn('Grid nie został znaleziony');
                    this.errorMsg("Konfiguracja tabeli nie została zapisana!");
                    return;
                }
                const tableId = 'warehouseStockLevelsGrid';
                const settings = grid.columns.map((column, index) => ({
                    field: column.field || null,
                    index: index,
                    width: column.width,
                    visible: column.visible !== false
                }));
                try {
                    const response = await axios.post('/table-settings', {
                        tableId: tableId,
                        columns: JSON.stringify(settings)
                    });
                    this.hasTableSettings = true;
                    grid.toolbar = this.getToolbar();
                    this.successMsg("Konfiguracja tabeli została pomyślnie zapisana!");
                } catch (error) {
                    this.errorMsg("Konfiguracja tabeli nie została zapisana!");
                }
            }
            if (args.item.id === 'delete-set') {
                const tableId = 'warehouseStockLevelsGrid';
                try {
                    const response = await axios.delete('/table-settings-delete', {
                        data: {
                            tableId: tableId
                        }
                    }
                    );
                    this.hasTableSettings = false;
                    const grid = this.$refs.warehouseStockLevelsGrid?.ej2Instances;

                    if (grid) {
                        grid.toolbar = this.getToolbar();
                    }
                    this.successMsg(
                        "Konfiguracja tabeli została pomyślnie usunięta!"
                    );
                } catch (error) {
                    this.errorMsg(
                        "Konfiguracja tabeli nie została usunięta!"
                    );
                }
            }

	  	  if (args?.item.id === 'restore') {
        let grid = this.$refs.warehouseStockLevelsGrid;
        let gridName = 'grid' + grid.$el.id;
        grid.ej2Instances.enablePersistence = false;
        window.localStorage.setItem(gridName, "");
        grid.ej2Instances.destroy();

        // usuń ?ids=... i/lub ids[]=... z aktualnego adresu
        (function stripIdsFromUrl() {
          try {
            const url = new URL(window.location.href);
            url.searchParams.delete('ids');    // np. ?ids=1,2,3
            url.searchParams.delete('ids[]');  // np. ?ids[]=1&ids[]=2
            history.replaceState(history.state, '', url.toString());
          } catch (e) {
            // fallback dla bardzo starych przeglądarek
            const href = window.location.href;
            const cleaned = href
                .replace(/([?&])ids(\[\])?=[^&#]*&?/g, '$1')
                .replace(/[?&]$/, '');
            history.replaceState(history.state, '', cleaned);
          }
        })();
this.applyTableSettings();
        location.reload();
      }

      if (args.item.id === 'excelexport') {
        this.$refs.warehouseStockLevelsGrid.excelExport({
          fileName: `Stany magazynowe.xlsx`
        });
      }
    },

    getContextMenu() {
      const contextMenu = [];

      if (hasPermission('canWarehouseDispositions')) {
        contextMenu.push(
            {text: 'Dyspozycja magazynowa', target: '.e-content', id: 'warehouse_disposition'},
        )
      }
      return contextMenu;
    },


    clickContextMenuHandler(args) {
      const selected = this.$refs.warehouseStockLevelsGrid.getSelectedRecords();

      if (!selected.length) {
        this.errorMsg('Najpierw zaznacz wiersz.');
        return;
      }

      if (args.item.id === 'warehouse_disposition') {
        this.$nextTick(async () => {
          this.selectedArticle = this.$refs.warehouseStockLevelsGrid.getSelectedRecords();

          // jeśli artykuł nie jest na stanie głównym to pokaż ostrzeżenie
          if (this.selectedArticle[0]?.article_warehouse_id !== 1) {
            await Toast.fire({
              position: 'center',
              toast: false,
              icon: 'info',
              title: 'Wybrano artykuł na inny magazynie niż główny',
              html: 'Wybrano artykuł, który znajduje się na magazynie ' + this.selectedArticle[0]?.article_warehouse?.short_name,
              showConfirmButton: true,
              confirmButtonText: 'OK',
              showCloseButton: true,
              timer: null, // bez auto-zamykania
              timerProgressBar: false
            });

          }
			this.showMoveItemToWarehouseModal = true;
			this.$nextTick(() => {
          this.$refs.moveItemToWarehouseModal.show();
		  });
        })
      }
    },

    rowSelecting(args) {
      if (this.preventRightClickSelection) {
        args.cancel = true;
        this.preventRightClickSelection = false;
      }
    },

    onRowSelected(args) {
      this.selectedArticle = args.data ?? {};
    },

    onContextMenuOpen(args) {
      const grid = this.$refs.warehouseStockLevelsGrid;
      if (!grid) return;

      const selected = grid.getSelectedRecords?.() || [];
      const rowInfo = grid.getRowInfo(args.event.target);
      const clickedRow = rowInfo?.rowData ?? null;

      // klik poza wierszem i brak selekcji
      if (!clickedRow && !selected.length) {
        args.cancel = true;
        return;
      }

      // klik w NIEZAZNACZONY wiersz
      if (clickedRow && !selected.length) {
        args.cancel = true;

      }

      // ✅ klik w ZAZNACZONY wiersz → menu OK
    },


    getWarehousesItemsForProject() {

      this.warehouseDataManager = new DataManager({
        url: route('warehouse.getArticleList'),
        adaptor: new WebMethodAdaptor(),
        crossDomain: true,
        headers: [
          {'X-CSRF-TOKEN': usePage().props.csrf_token}
        ],
      });
	              if (!this.tableSettingsApplied) {
                this.tableSettingsApplied = true;
                this.applyTableSettings();
            }
    },

    dateFormatter(field, data) {
      const date = data.created_at ? data.created_at : null;
      if (date) {
        try {
          return moment(date).format('DD.MM.YYYY HH:mm:ss');
        } catch (error) {
          return data
        }
      }

      return '';
    },

    onKeyDown: function (args) {
      let keyCode = args.which || args.keyCode;
      let isCtrlKey = (args.ctrlKey || args.metaKey) ? true : ((keyCode === 17));

      // code 83 to 'S'
      if (isCtrlKey && keyCode === 83) {
        args.preventDefault();

        // aktualizuj
        let toolbar = document.getElementsByClassName('e-toolbar-left')[0];
        let buttons = toolbar.querySelectorAll('.e-toolbar-item');
        let updateButton = buttons[2].querySelector('button');
        if (updateButton) {
          updateButton.click();

        }
      }
    },

    async onChangeWarehouse(event) {
      // Czy powraca co poprzedniej wartości,
      // Jeśli tak to nie pokazuj Toasta
      if (this.isRestoring) {
        this.isRestoring = false;
        return;
      }

      const result = await Toast.fire({
        toast: false,
        position: 'center',
        icon: 'question',
        title: 'Zmiana magazynu',
        html: 'Czy na pewno chcesz zmienić magazyn dla tego artykułu?',
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: false,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        confirmButtonColor: 'success',
        showCancelButton: true,
        cancelButtonText: 'Nie',
      });

      if (result.isConfirmed) {
        return event.itemData;
      } else {
        this.isRestoring = true;
        return event.previousItemData;
      }
    },

    selectDetailsBtn(elem) {
      this.selectedDetailWindow = elem;
    },
/*
    updateGrid() {
      this.$refs.warehouseStockLevelsGrid.refresh();
    },
*/
updateGrid() {
  const grid = this.$refs.warehouseStockLevelsGrid

  if (grid?.ej2Instances) {
    grid.ej2Instances.dataSource = this.warehouseDataManager
    grid.ej2Instances.refresh()
  }
},
    successMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'success',
        title: 'Sukces!',
        html: resp,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },

    errorMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'warning',
        title: 'Błąd!',
        html: resp,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },

    formatDeliverers(data) {
      // Paruj JSON i formatuj jako ciąg znaków
      try {
        const names = JSON.parse(data.deliverers_short_names);
        return names.join(', ');
      } catch (e) {
        // Jeśli dane nie są poprawnym JSON-em, zwróć je bez zmian
        return data.deliverers_short_names;
      }
    },

    isAdmin() {
      return hasRole('ADMIN');
    },

    actionBegin(args) {
      //
      // WYSZUKIWARKA- wyszukiwanie wielu wartości z separatorem (przecinek
      //
      if (args.requestType === 'searching') {
        const keys = args.searchString.split(',');
        let flag = true;
        let predicate;

        if (this.$refs.warehouseStockLevelsGrid.ej2Instances.searchSettings.key !== '') {
          this.values = args.searchString;
          keys.forEach((key) => {
            this.$refs.warehouseStockLevelsGrid.ej2Instances.getColumns().forEach((col) => {
              if (flag) {
                predicate = new Predicate(col.field, 'contains', key, true);
                flag = false;
              } else {
                let predic = new Predicate(col.field, 'contains', key, true);
                predicate = predicate.or(predic);
              }
            });
          });

          this.$refs.warehouseStockLevelsGrid.ej2Instances.query = new Query().where(predicate);
          this.$refs.warehouseStockLevelsGrid.ej2Instances.searchSettings.key = '';
          this.refresh = true;
          this.valueAssign = true;
          this.removeQuery = true;
          this.$refs.warehouseStockLevelsGrid.ej2Instances.refresh();
        } else {
          this.$refs.warehouseStockLevelsGrid.ej2Instances.searchSettings.key = '';
          this.refresh = true;
          this.valueAssign = true;
          this.removeQuery = true;
          this.$refs.warehouseStockLevelsGrid.ej2Instances.refresh();
        }
      }
    },

    actionComplete(args) {
      if (args.requestType === "batchsave") {  // Tylko dla operacji batchSave (zapis)
        if (args.changes && args.changes.changedRecords) {
          // Sprawdzamy czy `args.batchChanges` istnieje i czy są zmienione rekordy
          this.successMsg("Dane zostały pomyślnie zapisane!");

        } else if (args.error) {
          // Jeśli wystąpił błąd, wywołaj `errorMsg` z wiadomością błędu
          this.errorMsg("Wystąpił błąd podczas zapisu danych: " + args.error);
        }
      }

      //
      // WYSZUKIWARKA - wyszukiwanie wielu wartości z separatorem (przecinek
      //
      if (args.requestType === "refresh" && this.valueAssign) {
        document.getElementById(
            this.$refs.warehouseStockLevelsGrid.ej2Instances.element.id + "_searchbar"
        ).value = this.values;
        this.valueAssign = false;
      } else if (
          document.getElementById(
              this.$refs.warehouseStockLevelsGrid.ej2Instances.element.id + "_searchbar"
          ).value === "" &&
          args.requestType === "refresh" &&
          this.removeQuery
      ) {
        this.$refs.warehouseStockLevelsGrid.ej2Instances.query = new Query();
        this.removeQuery = false;
        this.$refs.warehouseStockLevelsGrid.ej2Instances.refresh();
      }
    },
  }
}
</script>

<style scoped>
.not-editable {
  color: orangered;
}
</style>